<template>
	<button
		type="button"
		class="p-1 shrink-0"
		@click="toggleUnderline"
		:title="$t('Underline')"
		tabindex="-1"
		:class="{
			active: isActive,
			'bg-indigo-200 rounded-md': isActive,
		}"
	>
		<UnderlineIcon class="w-5 h-5" />
	</button>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { UnderlineIcon } from "@heroicons/vue/24/outline";

export default defineComponent({
	name: "UnderlineButton",
	components: { UnderlineIcon },
	props: {
		editor: { type: Object as PropType<any>, required: false },
	},
	computed: {
		isActive(): boolean {
			return !!(this.editor as any)?.isActive?.("underline");
		},
	},
	methods: {
		toggleUnderline() {
			(this.editor as any)?.chain?.().focus().toggleUnderline().run();
		},
	},
});
</script>
